import React from 'react';

const MiModal = ({ isOpen, onRequestClose, onConfirm }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal">
                <h2>Este evento tiene una fila de espera.</h2>
                <h3>¿Deseas continuar con la compra?</h3>
                <div className="modal-buttons">
                    <button type="button" className="btn btn btn-secondary" onClick={onRequestClose}>No quiero continuar la compra</button>
                    <button type="button" className="btn btn btn-secondary" onClick={onConfirm}>Sí, espero mi turno en la fila</button>
                </div>
            </div>
        </div>
    );
}

export default MiModal;
